var guarantee = "https://shopfront-cdn.tekoapis.com/static/61b88b0a6893d3b0.svg";

export { guarantee as default };
